import Vue from 'www/vue_components'
import { initI18n, onDocumentReady } from 'www/utils'
import ClinicDoctorsFilter from './ClinicDoctorsFilter.vue'
import ClinicDoctorsFilterMain from './ClinicDoctorsFilterMain.vue'

const initApp = async () => {
  const rootEl = document.querySelector('.clinic-doctors-filter-wrapper')

  if (!rootEl) {
    return
  }

  const { i18next } = await initI18n({ bundle: 'vue_components/mobile/ClinicDoctorsFilter' })

  Vue.use(i18next)

  new Vue({
    el: rootEl,
    delimiters: ['[[', ']]'],
    components: {
      ClinicDoctorsFilter,
      ClinicDoctorsFilterMain,
    },
  })
}

onDocumentReady(initApp)
